import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import store from "./store";
import router from "./router";
import { Amplify } from "aws-amplify";

Amplify.configure({
 Auth: {
  userPoolId: "ap-south-1_feRf8GW4U",
  region: "ap-south-1",
  userPoolWebClientId: "7aigc1bd6t4k1crkcp2aueakg7",
 },
 API: {
  aws_project_region: "ap-south-1",
  aws_appsync_graphqlEndpoint:
   "https://hapsj4aod5gpnp4qg57zntllyu.appsync-api.ap-south-1.amazonaws.com/graphql",
  aws_appsync_region: "ap-south-1",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
 },
 endpoints: [
  {
   name: "Report_issue",
   endpoint:
    " https://61fvl4pi50.execute-api.ap-southeast-1.amazonaws.com/dev/",
  },
 ],
});
Vue.config.productionTip = false;

new Vue({
 vuetify,
 store,
 router,
 render: (h) => h(App),
}).$mount("#app");
